import { render, staticRenderFns } from "./error.component.vue?vue&type=template&id=13b46ca0&scoped=true&functional=true"
var script = {}
import style0 from "./error.component.vue?vue&type=style&index=0&id=13b46ca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "13b46ca0",
  null
  
)

export default component.exports